import i18n from 'i18next';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { emitAnalytics, getTelemetryDeviceType } from '../../../../src/services/telemetry/appInsights';
import { useAuthContext } from '../../../contexts/AuthContext';
import { useUrlContext } from '../../../contexts/UrlContext';

const LegacyMigrateDesktopPart = () => {
  const { t } = useTranslation();

  const { userInfo } = useAuthContext();
  const { redirectToMicrosoftAuth } = useUrlContext();

  const handleConnectClick = () => {
    const email = userInfo?.contact?.email;
    if (!email) return;
    emitAnalytics('part_login_redirected_to_ms', {
      entryRoute: '/part/legacyMigrate',
      deviceType: getTelemetryDeviceType(),
      language: i18n.language,
    });
    redirectToMicrosoftAuth('b2c', email);
  };

  return (
    <div
      style={{
        width: 1761,
        height: 878,
        position: 'relative',
        background: '#F6F8FB',
        overflow: 'hidden',
        borderRadius: 32,
        color: '#323E48',
        marginBottom: 20,
      }}
    >
      {/* Fond gris haut (même logique que HomePageDesktopPart) */}
      <div
        style={{
          position: 'absolute',
          width: 1761,
          height: 683,
          borderRadius: '32px 32px 0px 0px',
          background: '#F6F8FB',
        }}
      />

      {/* Bloc centré : cercle + carte blanche */}
      <div
        style={{
          position: 'absolute',
          top: 140,
          left: 0,
          right: 0,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        {/* 1) Cercle "Sécurité du compte" */}
        <img
          src="/images/icone05.svg"
          alt="Réinitialisation du mot de passe"
          style={{ width: 240, height: 240, objectFit: 'contain', marginBottom: 60 }}
        />

        {/* 2) Carte blanche avec texte + bouton */}
        <div
          style={{
            width: 1040,
            minHeight: 200,
            background: '#FFFFFF',
            borderRadius: 32,
            boxShadow: '0px 10px 40px rgba(0, 0, 0, 0.06)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '60px 40px 50px',
            textAlign: 'center',
          }}
        >
          <div
            style={{
              fontSize: 28,
              fontWeight: 500,
              color: '#024D71',
              marginBottom: 16,
            }}
          >
            {t('createPart:title')}
          </div>

          <div
            style={{
              fontSize: 16,
              fontWeight: 600,
              textTransform: 'uppercase',
              letterSpacing: 0.5,
              color: '#61AFA1',
              marginBottom: 16,
            }}
          >
            {t('createPart:subtitle')}
          </div>

          <div
            style={{
              fontSize: 16,
              color: '#024D71',
              marginBottom: 60,
              fontWeight: 500
            }}
          >
            {t('createPart:content')}
          </div>

          <button
            type="button"
            onClick={handleConnectClick}
            style={{
              padding: '0px 20px',
              height: 48,
              borderRadius: 10,
              backgroundColor: '#FF4D00',
              color: '#FFFFFF',
              border: 'none',
              fontSize: 19,
              fontWeight: 'bold',
              cursor: 'pointer',
              textTransform: 'uppercase',
              fontFamily: 'Montserrat, sans-serif',
            }}
          >
            {t('createPart:button_text')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default LegacyMigrateDesktopPart;
